import { useQueryClient } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineGroupEventsApi } from '@/features/api/hooks/grapevine-group-events/useGrapevineGroupEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const useRemoveGroupMember = (groupId: string) => {
  const queryClient = useQueryClient();
  const api = useGrapevineGroupEventsApi();

  return useApiMutation({
    mutationFn: (memberId: string) =>
      api.onGroupRemoveMemberRequest({
        clientGroupRemoveMemberRequest: { groupId, memberIdToRemove: memberId }
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.GROUP_MEMBERS, groupId]
      });
      // to update memberCount
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.GROUP, groupId]
      });
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.GROUPS]
      });
    }
  });
};
